import {internalApi, gitlabApi} from "../../common/axios";
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";
import {buildUrl} from "../../shared/utils/net";
import toast from "react-hot-toast";

const fetchCSVList = async () => {
    const {data} = await internalApi.get("manager");
    return data.rows;
}

export const useCSVList = () => {
    return useQueryBase('csvList', fetchCSVList,{staleTime: 0});
}

// TODO: GitLab 업로드 추후 삭제 예정
const uploadCSV = async ({ version, branch }) => {
    await internalApi.post("manager", { version, branch });
}

export const useUploadCSV = () => {
    return useMutationBase('csvList', uploadCSV);
}

const uploadCSVLocal = async ({ version, files }) => {
    const formData = new FormData();
    formData.append('version', version);
    files.forEach(file => formData.append('files', file));
    await internalApi.post("manager/localUpload", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

export const useUploadCSVLocal = () => {
    return useMutationBase('csvList', uploadCSVLocal);
}

const deleteCSV = async (versionToDelete) => {
    await internalApi.post("manager/csvDelete", { path: versionToDelete } );
}

export const useDeleteCSV = () => {
    return useMutationBase('csvList', deleteCSV);
}

// TODO: GitLab 업로드 추후 삭제 예정
const fetchGitlabBranchList = async () => {
    let page = 1;
    const perPage = 100;
    let allBranches = [];
    let hasMore = true;

    while (hasMore) {
        const { data } = await gitlabApi.get("repository/branches", {
            params: { per_page: perPage, page }
        });
        allBranches = allBranches.concat(data);
        hasMore = data.length === perPage;
        page += 1;
    }
    return allBranches.map(branch => branch.name);
}

export const useGitlabBranchList = () => {
    return useQueryBase('branchList', fetchGitlabBranchList);
}

const fetchGameDataConfig = async (key) => {
    const {data} = await internalApi.get(buildUrl('manager/dataConfig', {key}));
    return data.data;
}

export const useGameDataConfig = (key) => {
    return useQueryBase([`gameDataConfig`, key], () => fetchGameDataConfig(key), {staleTime: 0});
}

const fetchCsvMemo = async () => {
    const {data} = await internalApi.get('manager/csv/memo');
    return Object.fromEntries((data.rows || []).map(r => [r.version, r.memo]));
}

export const useCsvMemo = () => {
    return useQueryBase('csvMemo', fetchCsvMemo, {staleTime: 0});
}

const saveCsvMemoApi = async ({version, memo}) => {
    await internalApi.post('manager/csv/memo', {version, memo});
}

export const useSaveCsvMemo = () => {
    return useMutationBase('csvMemo', saveCsvMemoApi);
}

const saveGameDataConfig = async ({config, key}) => {
    try {
        const res = await internalApi.post('manager/dataConfig', {config, key});
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("저장 실패");
    }
}

export const useSaveGameDataConfig = () => {
    return useMutationBase([`gameDataConfig`],saveGameDataConfig);
}